"use strict";

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var setProperty = (model, propertyName, propertyValue) => {
	var propertyParts = propertyName.split(".");
	var ref = model;
	propertyParts.forEach(function (propertyPart, index) {
		if (index < propertyParts.length - 1) {
			if (!ref[propertyPart]) {
				ref[propertyPart] = {};
			}
			ref = ref[propertyPart];
		} else {
			ref[propertyPart] = propertyValue;
		};
	});
};

var ActionsHelper = {
	formatAmount: function(value, $element, keepDecimals, includeThousandsSeparator) {
		if (value == null) { //coercion because I want undefined as well but not 0
			return value;
		}

		//We are doing this so that we can have the same method name for the two different methods
		if (!($element instanceof jQuery)) {
			return this.formatAmountValue(...arguments);
		}

		$element = $element || $(null);
		//If we are a link, the showDecimals and includeCurrencySymbol are stored on the parent
		if ($element.is(`[data-component="link"]`)) {
			$element = $element.parent();
		}

		var includeCurrencySymbol = $element.is("[data-include-currency-symbol]");
		var showDecimals = $element.is("[data-show-decimals]");

		return this.formatAmountValue(value, showDecimals, includeCurrencySymbol, keepDecimals, includeThousandsSeparator);
	},

	// If keepDecimals, do not format out the decimals.  This is most often used when a user is typing an amount.
	formatAmountValue: function(amount, showDecimals, includeCurrencySymbol, keepDecimals, includeThousandsSeparator) {
		var formattedAmount = parseFloat(Number(amount) || 0);
		var numberDecimals = 0;
		if (showDecimals || formattedAmount % 1 !== 0) {
			// If we have any decimal amount, force decimals
			// i.e. amount is 66.5, we want to show 66.50
			numberDecimals = 2;
		}

		if (!keepDecimals) {
			formattedAmount = formattedAmount.toFixed(numberDecimals);
		}

		// Add commas in (but only to the part before the decimal)
		var parts = formattedAmount.toString().split(".");
		if (includeThousandsSeparator == null) {
			// Defaulting to true
			includeThousandsSeparator = true;
		}
		if (includeThousandsSeparator) {
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, window.currencyFormat.thousandsSeparator);
		}
		if (keepDecimals && parts.length === 1 && numberDecimals !== 0) {
			// The number entered either did not have decimals or had 00, and we want to show decimals
			parts[1] = "0";
		}
		if (parts.length === 2) {
			// Make sure we have the right number of 0s on the end
			// "0" => "00"
			// "50" => "50"
			// "5" => "50"
			// "55" => "55"
			parts[1] = parts[1].padEnd(numberDecimals, "0");
		}
		formattedAmount = parts.join(window.currencyFormat.decimalSeparator);
		if (includeCurrencySymbol && window.currencyFormat.currencySymbol) {
			if (window.currencyFormat.isCurrencySymbolInFront) {
				formattedAmount = window.currencyFormat.currencySymbol + formattedAmount;
			} else {
				formattedAmount = formattedAmount + window.currencyFormat.currencySymbol;
			}
		}

		return formattedAmount;
	},

	replaceAmountDecimalSymbols: function(numberString) {
		//We are specifically using coercion here to do equality for null and undefined
		numberString = (numberString == null ? "" : numberString).toString().replace(/\./g, window.currencyFormat.decimalSeparator);
		return numberString;
	},

	// useCurrencyFormatDecimalSeparator would most likely be true if we are formatting a number to put in an input (amount) field
	convertFormattedAmountToNumberString: function(formattedAmount, useCurrencyFormatDecimalSeparator) {
		formattedAmount = (formattedAmount || "").toString();
		var currencyRegex = new RegExp(this.escapeRegExp(window.currencyFormat.currencySymbol), "g");
		var decimalRegex = new RegExp(this.escapeRegExp(window.currencyFormat.decimalSeparator), "g");
		var thousandsRegex = new RegExp(this.escapeRegExp(window.currencyFormat.thousandsSeparator), "g");

		//Remove Currency Symbol
		formattedAmount = formattedAmount.replace(currencyRegex, "");
		//Remove Thousands Separator
		formattedAmount = formattedAmount.replace(thousandsRegex, "");
		//Replace Decimal Separator with period
		if (!useCurrencyFormatDecimalSeparator && window.currencyFormat.decimalSeparator !== ".") {
			formattedAmount = formattedAmount.replace(decimalRegex, ".");
		}

		return formattedAmount;
	},

	convertFormattedAmountToNumber: function(formattedAmount) {
		formattedAmount = this.convertFormattedAmountToNumberString(formattedAmount);

		return parseFloat(Number(formattedAmount) || 0);
	},

	escapeRegExp: function(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
	},

	// This method should only be used when processing events which alter internal component UI state.
	// Any component which has a click event which performs an external action (like navigation) should not use this method.
	getEventOrReturn: function(event, isDesignMode, isDesignModeMessage, preventDefaultInDesignMode) {
		//We are specifically using coercion here to do equality for null and undefined
		preventDefaultInDesignMode = preventDefaultInDesignMode == null ? true : preventDefaultInDesignMode;

		if (!event) {
			return;
		}

		if (!isDesignMode || preventDefaultInDesignMode) {
			event.preventDefault();
		}

		if (isDesignMode) {
			if (event.ctrlKey || event.metaKey) {
				// We don't want a new tab to be opened when ctrl+clicking a link in design mode when using this
				// method. Instead we are popping a Bootstrap dialog with a message to the user.
				// Stopping propagation has the side-effect of preventing the Property Editor from loading, but that is
				// expected on ctrl+click.
				if (event.type === "click" && event.target && event.target.tagName === "A") {
					event.stopPropagation();
				}
				BootstrapPrompt.success(isDesignModeMessage);
			}
			return;
		} else {
			event.stopPropagation();
		}

		return event;
	},

	serializeForm: function (selector) {
		var $form = $(selector);

		//For the createAccountForm, if we have a hidden accountType.individual or accountType.organization, we want to make sure to disable the "inputs" on it so they are not submitted to the server.
		var $hiddenInputs = $form.find(`[data-component="accountType"] > div:hidden input:enabled:hidden,[data-component="accountType"] > div:hidden select:enabled:hidden,[data-component="accountType"] > div:hidden textarea:enabled:hidden,[name='address.state.inactive']`);
		$hiddenInputs.prop("disabled", true);

		var data = $form.serializeArray().reduce((obj, item) => {
			setProperty(obj, item.name, item.value);
			return obj;
		}, {});

		//Setting the "inputs" back to how they were
		$hiddenInputs.prop("disabled", false);

		return data;
	}
};

module.exports = ActionsHelper;



// WEBPACK FOOTER //
// ./Javascript/actions/ActionsHelper.jsx